import React from 'react';
import usePermissao from '../hooks';
import { Permissoes } from '../ts/enums/PermissoesEnum';
import { Navigate } from 'react-router-dom';

export const RotaProtegida: React.FC<{ permissoesNecessarias: Permissoes[]; children: React.ReactElement }> = ({
	permissoesNecessarias,
	children,
}) => {
	const temPermissao = usePermissao(permissoesNecessarias);

	if (!temPermissao) {
		return <Navigate to='/sem-permissao' replace />;
	}

	return children;
};
